import { render, staticRenderFns } from "./FysioRoadmap.vue?vue&type=template&id=6cf6e7dc&"
import script from "./FysioRoadmap.vue?vue&type=script&lang=js&"
export * from "./FysioRoadmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports